import { useCallback } from 'react';

import { openAsyncLink } from '../../helpers';

import { useGetFileLinkPreview } from './useGetFileLinkPreview';

export const usePreviewFile = () => {
  const { getFileLink, loading } = useGetFileLinkPreview();

  const handleDownloadFile = useCallback(
    async (fileId: string) => {
      openAsyncLink(() => getFileLink(fileId));
    },
    [getFileLink]
  );

  return {
    previewFile: handleDownloadFile,
    loading,
  };
};
